import React from "react";
import IconLink from "./IconLink";
import { MyOffersIcon as MyOffersIconComponent } from "./icons";

export interface MyOffersIconProps {
  className?: string;
  "data-testid"?: string;
  href?: string;
  onMyOffersClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  notification?: string;
}

const MyOffersIcon: React.FC<MyOffersIconProps> = ({
  className,
  "data-testid": dataTestId,
  href,
  onMyOffersClick,
  notification,
}) => {
  return (
    <IconLink
      href={href ?? "/myoffers.page"}
      icon={<MyOffersIconComponent />}
      label="My Offers"
      onClick={onMyOffersClick}
      data-testid={dataTestId || "header-my-offers-icon"}
      ariaLabel="My Offers"
      className={`${className || ""} my-offers`}
      notification={notification}
    />
  );
};

export default React.memo(MyOffersIcon);
